// Generated from auth/client/ by scripts/sync-auth-client.mjs. Do not edit here.
// Authentication guard: every page needs a signed-in user.
//
// On *.tafiti.dev, ensureAuthenticated() sends the browser to the shared
// sign-in page, which returns here afterwards. Elsewhere (drlugha.com) the
// previous guard in legacy-auth-guard.js is used unchanged.

import { googleAuthService } from './google-auth.js';
import { usesSharedAuth } from './tafiti-auth.js';
import { authGuardService as legacyAuthGuardService } from './legacy-auth-guard.js';

class SharedAuthGuardService {
  async checkAuthenticationRequired() {
    return true;
  }

  async isAuthenticated() {
    try {
      return await googleAuthService.initialize();
    } catch (error) {
      console.error('Authentication check failed:', error);
      return false;
    }
  }

  /**
   * Resolves true when signed in. Otherwise navigates to the sign-in page and
   * never resolves, so callers simply stop where they are.
   */
  async ensureAuthenticated() {
    if (await this.isAuthenticated()) return true;
    return googleAuthService.signIn();
  }

  async shouldRequireAuth() {
    return true;
  }

  getCurrentUser() {
    return googleAuthService.getUserInfo();
  }

  async signOut() {
    await googleAuthService.signOut();
    return true;
  }
}

export const authGuardService = usesSharedAuth() ? new SharedAuthGuardService() : legacyAuthGuardService;
